/* eslint-disable */
import Vue from "vue";
import store from "../index.js";

const state = {
  collection: {
    polls: [],

    poll: {},
    voters: [],
    agents: [],
    sections: [],
    analytics: {},

    voterData: {},
    overview: {},
  },
};

const getters = {
  getCollection: (state) => (collectionName) => {
    const cn = collectionName;

    if (state.collection[cn]) return state.collection[cn];
    console.error(`No collection with name ${cn}!`);
    return [];
  },
};

const actions = {
  makeFetch: async ({ commit }, payload) => {
    let url = `${process.env.VUE_APP_BACKEND_API_ENDPOINT}`;

    if (payload.goTo) url = `${url}${payload.goTo}`;

    if (payload.useId) {
      const { useId } = payload;
      if (typeof useId == "boolean")
        url = `${url}/${state.collection.active_tt.id}`;
      else if (typeof useId !== "boolean") url = `${url}/${useId}`;
    }

    if (payload.way) url = `${url}${payload.way}`;

    let tkn = localStorage.getItem("tkn") || sessionStorage.getItem("tkn");
    if(payload.useToken) tkn = payload.useToken;

    const method = payload.method
      ? String(payload.method).toUpperCase()
      : "GET";

    let fetchOptions = {
      method: method,
      headers: {
        Authorization: "Bearer " + tkn,
      },
    };

    const moreHeaders = {
      "Content-Type": "application/json",
    };

    const noBodyReqMethods = ["GET", "HEAD"];
    noBodyReqMethods.includes(method) ||
      (fetchOptions = {
        ...fetchOptions,
        headers: {
          ...fetchOptions.headers,
          ...moreHeaders,
        },
        body: JSON.stringify(payload.data),
      });

    const response = await fetch(url, fetchOptions);

    if (response.ok) {
      const jsonBody = await response.json();

      if (jsonBody.error && jsonBody.error == "expired_token" && !payload.useToken) {
        store.dispatch("userAuth", { logout: true });
        setTimeout(() => {
          window.location.reload();
        }, 500);
        return;
      }

      if (payload.stateVar) {
        commit("SET_COLLECTION", {
          jsonBody,
          target: payload.stateVar,
        });
      }

      return jsonBody;
    }

    console.error("Failed to Fetch");
    return false;
  },

  updateCollection({ commit }, payload) {
    commit("UPDATE_STATE", payload);
  },
};

const mutations = {
  SET_COLLECTION(state, payload) {
    const { target } = payload;
    const body = payload.jsonBody.data;

    if (!state.collection[target]) {
      Vue.set(state.collection, target, body);
    } else {
      if (["string", "boolean", "number"].includes(typeof data)) {
        // string/boolean/number
        state.collection[target] = body;
      } else if (Array.isArray(body)) {
        // array
        state.collection[target] = [...body];
      } else if (typeof body == "object") {
        // object
        state.collection[target] = { ...body };
      }
    }
  },

  UPDATE_STATE(state, payload) {
    const { cn, data, mode } = payload;

    if (!state.collection[cn]) {
      // collection does not exist
      console.error(`No collection with name ${cn}`);
    } else if (
      ["string", "boolean", "number"].includes(typeof state.collection[cn])
    ) {
      // string/boolean/number
      state.collection[cn] = data;
    } else if (Array.isArray(state.collection[cn])) {
      // array
      if (mode == "push") state.collection[cn].push(data);
      else state.collection[cn] = [...data];
    } else if (typeof state.collection[cn] == "object") {
      // object
      state.collection[cn] = { ...data };
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
